import { createSlice } from "@reduxjs/toolkit";
import { NameValueEntity } from "../../../models/Common";
import { AppThunk } from "../../store";

interface IProps {
    partCategories: Array<NameValueEntity>
}

const initialState: IProps = {
    partCategories: []
}

const PartsSlice = createSlice({
    name: "Parts",
    initialState,
    reducers: {
        setPartCategoriesAction: (state, action) => {
            state.partCategories = action.payload;
        }
    }
});

export const {
    setPartCategoriesAction
} = PartsSlice.actions;

export const setPartCategories = (value: NameValueEntity[]) : AppThunk => (dispatch, getState) => {
    dispatch(setPartCategoriesAction(value));
}

export default PartsSlice.reducer;